import api from '../api/api.js'

export default {
  namespaced: true,

  state: {
    itemId: '',
    selectedSkuId: '',
    skulist: []
  },

  getters: {
    itemId(state) {
      return state.itemId
    },
    selectedSkuId(state) {
      return state.selectedSkuId
    },
    skulist(state) {
      return state.skulist
    }
  },

  mutations: {
    selectedSkuId(state, payload) {
      state.selectedSkuId = payload
    },
    skulist(state, payload) {
      state.itemId = payload.itemId
      state.skulist = payload.skulist
    },
    reset(state) {
      state.itemId = ''
      state.selectedSkuId = ''
      state.skulist = []
    }
  },

  actions: {
    /**
     * sku一覧取得
     */
    getSkulist({ commit }, payload) {
      commit('reset')
      const data = {
        item_id: payload.itemId
      }

      api.get('/api/v2/skulist/get', data)
        .then((res) => {
          const skulist = res.data.skulist
          commit('skulist', {
            itemId: payload.itemId,
            skulist: skulist
          })
        })
    },

    /**
     * 選択したskuを設定
     * ページ遷移を考慮して保存しておく
     */
    setSelectedSkuId({ commit }, payload) {
      commit('selectedSkuId', payload)
    },

    /**
     * 初期化
     */
    resetSkulist({ commit }) {
      commit('reset')
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/module/skulist.js